import { render, staticRenderFns } from "./SpellsCardLevel.vue?vue&type=template&id=626062b6&scoped=true&"
import script from "./SpellsCardLevel.vue?vue&type=script&lang=js&"
export * from "./SpellsCardLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626062b6",
  null
  
)

export default component.exports